import React, { useEffect } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import { find } from "lodash";
import Controls from "../../components/controls";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormControl-root": {
      width: "100%",
      margin: theme.spacing(1),
    },
  },
}));

export default function AssistantForm(props) {
  const { saveAssistant, users, assistants } = props;
  const { handleSubmit, reset, control, errors } = useForm();

  const classes = useStyles();

  const getUserOptions = () => {
    let notemp = [];
    users.forEach((c) => {
      if (!find(assistants, { id: c.id })) {
        notemp.push(c);
      }
    });

    return notemp.map((user) => {
      return {
        id: user.id,
        title: user.dropdownname ? user.dropdownname : user.first_name,
      };
    });
  };

  const onSubmit = (data) => {
    saveAssistant(data);
    reset();
  };

  useEffect(() => {
    getUserOptions();
  }, [assistants, users]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            name="assistantsToAdd"
            control={control}
            defaultValue=""
            as={({ onChange }) => (
              <Controls.Select
                label="Users"
                options={getUserOptions()}
                onChange={(newValue) => {
                  onChange(newValue);
                }}
              />
            )}
            rules={{ required: "Assistant is required" }}
          />
          {errors.roles && <p className="error">{errors.roles.message}</p>}

          <div>
            <Controls.Button type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </form>
  );
}
